import CommentForm from './CommentForm'
import CommentFormContianer from './CommentFormContainer'

export default CommentFormContianer(CommentForm)
